import { useState } from "react"

import { Flex, Form, Tag, Typography } from "antd"
import cls from "classname"
import { useTranslation } from "react-i18next"

import ButtonComponent from "../../../Components/Button"
import { SupportedPlatforms } from "../../../Components/SupportedPlatforms"
import Icon from "../../../Icon"
import Images from "../../../Images"
import { serviceImg } from "../../../Utils/utils"
import ThresholdInput from "./components/ThresholdInput"

import "./styles.less"

const { Text } = Typography

const data = {
  other: [
    {
      type: "Ethoca",
      brand: "mastercard",
      tag: { text: "Instant", icon: "clock_outlined_bold", type: "success" }
    },
    {
      type: "CDRN",
      brand: "visa",
      tag: { text: "Instant", icon: "clock_outlined_bold", type: "success" }
    }
  ],
  rdr: [
    {
      type: "RDR",
      brand: "visa",
      tag: { text: "Up to 5 business days", icon: "clock_filled", type: "warning" }
    }
  ],
  auto_cancel_amount: [
    {
      type: "Ethoca",
      brand: "mastercard",
      tag: { text: "Supported", icon: null, type: "success" },
      supportedPlatforms: ["stripe"]
    },
    {
      type: "CDRN",
      brand: "visa",
      tag: { text: "Supported", icon: null, type: "success" },
      supportedPlatforms: ["stripe"]
    },
    {
      type: "RDR",
      brand: "visa",
      tag: { text: "Unsupported", icon: null, type: "disabled" },
      supportedPlatforms: null
    }
  ]
}

const label = {
  other: "Auto-refund amount",
  rdr: "Auto-refund amount",
  auto_cancel_amount: "Auto-cancel amount"
}

const infoText = {
  other: "Changes to the auto-refund amount take effect instantly for Ethoca and CDRN.",
  rdr: "Changes to the auto-refund amount for RDR may take up to 5 business days to take effect.",
  auto_cancel_amount: "The auto-cancel feature is only supported for Ethoca and CDRN."
}

function ChangeRefundForm({
  onClose,
  onSubmit,
  initialAmount,
  type,
  theme,
  submitDisabled,
  isMobile
}) {
  const { t } = useTranslation()

  const [form] = Form.useForm()

  const [optionSelected, setOptionSelected] = useState(initialAmount === 0 ? "all" : "threshold")

  const value = Form.useWatch("amount", form)

  const onFinish = (value) => {
    onSubmit(value["amount"])
  }
  const handleClose = () => {
    onClose()
  }

  const disabled = (optionSelected === "threshold" && !value) || submitDisabled

  return (
    <Form
      onFinish={onFinish}
      //onFinishFailed={onFinishFailed}
      validateTrigger="onSubmit"
      layout="vertical"
      form={form}
      initialValues={{ amount: initialAmount }}
      requiredMark={false}
      style={{ marginTop: 16 }}
      className="change-refund-form"
    >
      <Form.Item name="amount" style={{ marginBottom: 8 }}>
        <ThresholdInput
          formType={type === "auto_cancel_amount" ? "auto_cancel" : "auto_refund"}
          onOptionChange={setOptionSelected}
        />
      </Form.Item>

      <Form.Item noStyle>
        <Flex vertical className="info-list">
          {data[type].map((item) => (
            <Flex vertical={true} gap={5} style={{ width: "100%" }} className="list-item">
              <Flex gap={8} justify="space-between" align={"center"}>
                <Flex gap={8} align={"center"}>
                  <img src={Images[serviceImg[theme][item.type?.toLowerCase()]]} alt={item.type} />
                  <Text strong>{item.type}</Text>
                </Flex>
                <Tag
                  bordered={false}
                  icon={
                    item?.tag?.icon ? <Icon type={item.tag.icon} style={{ fontSize: 16 }} /> : null
                  }
                  color={item.tag.type}
                  style={{ margin: 0, padding: "3px 7px", display: "flex", alignItems: "center" }}
                  className={cls("color-text", "change-refund-form-tag", {
                    only_color_text: !item.tag.icon,
                    disabled: item.tag.type === "disabled"
                  })}
                >
                  <Text>{item.tag.text}</Text>
                </Tag>
              </Flex>

              {item.tag.icon ? null : (
                <SupportedPlatforms variant="filled" list={item.supportedPlatforms} />
              )}
            </Flex>
          ))}
        </Flex>
      </Form.Item>

      <Flex
        gap={16}
        justify="end"
        style={{ padding: "0 3px 3px 0", marginTop: 24, flexDirection: isMobile && "column" }}
      >
        <ButtonComponent size="large" htmlType="button" onClick={handleClose}>
          {t("Cancel")}
        </ButtonComponent>

        <ButtonComponent type="primary" size="large" htmlType="submit" disabled={disabled}>
          {t("Confirm")}
        </ButtonComponent>
      </Flex>
    </Form>
  )
}

export default ChangeRefundForm
